import * as t from "react";
function n(t, n, r) {
  var e = "undefined" != typeof window;
  if (!e) throw Error("Hotjar depends on window. Window is undefined.");
  if (function (t, n) {
    try {
      var r = document.getElementById(n) || document.createElement("script");
      return r.id = n, r.innerText = t, r.crossOrigin = "anonymous", document.head.appendChild(r), !0;
    } catch (t) {
      return !1;
    }
  }("(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:".concat(t, ",hjsv:").concat(n, ",hjdebug:").concat(r, "};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');"), "hotjar-init-script") && e && window.hj) return !0;
  throw Error("Hotjar initialization failed!");
}
function r() {
  var r = !("undefined" == typeof window || !window.hj),
    e = t.useState(t.useMemo(function () {
      return r;
    }, [r])),
    o = e[0],
    i = e[1],
    a = t.useCallback(function (t, r, e, o) {
      try {
        return n(t, r, !!e), i(!0), o && "function" == typeof o && o("Hotjar ready: true"), !0;
      } catch (t) {
        return console.error("Hotjar error: ".concat(t.message)), !1;
      }
    }, []),
    c = t.useCallback(function (t, n, r) {
      try {
        return function (t, n) {
          if ("undefined" != typeof window && window.hj) return window.hj("identify", t, n);
          throw Error("Hotjar is not available! Is Hotjar initialized?");
        }(t, n), r && "function" == typeof r && r("Hotjar identified"), !0;
      } catch (t) {
        return console.error("Hotjar error: ".concat(t.message)), !1;
      }
    }, []),
    d = t.useCallback(function (t, n) {
      try {
        return function (t) {
          if ("undefined" != typeof window && window.hj) return window.hj("stateChange", t);
          throw Error("Hotjar is not available! Is Hotjar initialized?");
        }(t), n && "function" == typeof n && n("Hotjar stateChanged"), !0;
      } catch (t) {
        return console.error("Hotjar error: ".concat(t.message)), !1;
      }
    }, []),
    u = t.useCallback(function (t, n) {
      try {
        return function (t) {
          if ("undefined" != typeof window && window.hj) return window.hj("tagRecording", t);
          throw Error("Hotjar is not available! Is Hotjar initialized?");
        }(t), n && "function" == typeof n && n("Hotjar tagRecording"), !0;
      } catch (t) {
        return console.error("Hotjar error: ".concat(t.message)), !1;
      }
    }, []);
  return t.useMemo(function () {
    return {
      readyState: o,
      stateChange: d,
      tagRecording: u,
      initHotjar: a,
      identifyHotjar: c
    };
  }, [o, d, u, a, c]);
}
export { r as default };